import req from "./index";


/*登录*/
export const loginApi = (param = {}) => {
    return req.paramReq("post","/login", param);
};


/*学校*/
//列表
export const schoolListApi = (param = {}) => {
    return req.paramReq("get","/system/school/list", param);
};
//分页
export const schoolPageApi = (param = {}) => {
    return req.paramReq("get","/system/school/page", param);
};
//保存
export const schoolSaveApi = (param = {}) => {
    return req.dataReq("post","/system/school/save", param);
};
//开关负载
export const schoolSwitchApi = (param = {}) => {
    return req.paramReq("put","/system/school/switch", param);
};
//编辑
export const schoolUpdateApi = (param = {}) => {
    return req.dataReq("put","/system/school/update", param);
};


/*CP学生列表*/
//导入学生信息
export const importStudentInfoApi = (param = {}) => {
    return req.dataReq("post","/cp/student/import_student_info", param);
};
//班级列表
export const levelListApi = (param = {}) => {
    return req.paramReq("get","/cp/student/level_list", param);
};
//班级树
export const levelTreeApi = (param = {}) => {
    return req.paramReq("get","/cp/student/level_tree", param);
};
//分页
export const cpStudentPageApi = (param = {}) => {
    return req.paramReq("get","/cp/student/page", param);
};
//获取学生家长列表
export const parentListApi = (param = {}) => {
    return req.paramReq("get","/cp/student/parent_list", param);
};
//发送家长信息
export const sendParentMessageApi = (param = {}) => {
    return req.dataReq("post","/cp/student/send_parent_message", param);
};
//全校数据同步
export const cpStudentSyncApi = (param = {}) => {
    return req.paramReq("get","/cp/student/sync", param);
};
//学生单同步
export const syncOneApi = (param = {}) => {
    return req.paramReq("get","/cp/student/sync_one", param);
};
//更新学生信息
export const updateStudentInfoApi = (param = {}) => {
    return req.dataReq("put","/cp/student/update_student_info", param);
};
//上传学生信息
export const uploadStudentInfoApi = (param = {}) => {
    return req.dataReq("post","/cp/student/upload_student_info", param);
};
//获取学生信息
export const cpLikeNameApi = (param = {}) => {
    return req.paramReq("get","/cp/student/like_name", param);
};


/*Hik学生列表*/
//班级树
export const classTreeApi = (param = {}) => {
    return req.paramReq("get","/hik/student/class_tree", param);
};
//分页
export const hikStudentPageApi = (param = {}) => {
    return req.paramReq("get","/hik/student/page", param);
};
//数据同步
export const hikStudentSyncApi = (param = {}) => {
    return req.paramReq("get","/hik/student/sync", param);
};


/*授权学生列表*/
//授权列表
export const authorizePageApi = (param = {}) => {
    return req.paramReq("get","/authorize/student/page", param);
};
//账号是否推送
export const authorizeIsPushApi = (param = {}) => {
    return req.paramReq("get","/authorize/student/is_push", param);
};
//授权账号时间
export const authorizeAccountExpiredApi = (param = {}) => {
    return req.dataReq("put","/authorize/student/authorize_account_expired", param);
};
//班级树
export const authorizeClassTreeApi = (param = {}) => {
    return req.paramReq("get","/authorize/student/class_tree", param);
};
//获取学生信息
export const authorizeLikeNameTreeApi = (param = {}) => {
    return req.paramReq("get","/authorize/student/like_name", param);
};


/*推送日志*/
//分页
export const messagePageApi = (param = {}) => {
    return req.paramReq("get","/system/message/page", param);
};
//重新推送
export const againPushApi = (param = {}) => {
    return req.paramReq("get","/system/message/again_push", param);
};


/*用户*/
//分页
export const userPageApi = (param = {}) => {
    return req.paramReq("get","/system/user/page", param);
};
//删除
export const userDeleteApi = (param = {}) => {
    return req.paramReq("delete","/system/user/delete", param);
};
//是否开启登录
export const userEnabledApi = (param = {}) => {
    return req.dataReq("put","/system/user/enabled", param);
};
//添加用户
export const userSaveApi = (param = {}) => {
    return req.dataReq("post","/system/user/save", param);
};
//修改用户
export const userUpdateApi = (param = {}) => {
    return req.dataReq("put","/system/user/update", param);
};


/*订单*/
//分页
export const orderPageApi = (param = {}) => {
    return req.paramReq("get","/system/order/page", param);
};
//退款
export const orderRefundsApi = (param = {}) => {
    return req.paramReq("get","/system/order/refunds", param);
};
//处理订单
export const orderHandleApi = (param = {}) => {
    return req.paramReq("get","/system/order/handle", param);
};
//获取学生信息
export const orderLikeNameApi = (param = {}) => {
    return req.paramReq("get","/system/order/like_name", param);
};


/*项目*/
//分页
export const projectPageApi = (param = {}) => {
    return req.paramReq("get","/system/project/page", param);
};
//删除
export const projectDeleteApi = (param = {}) => {
    return req.paramReq("delete","/system/project/delete", param);
};
//添加项目
export const projectSaveApi = (param = {}) => {
    return req.dataReq("post","/system/project/save", param);
};
//修改项目
export const projectUpdateApi = (param = {}) => {
    return req.dataReq("put","/system/project/update", param);
};